import SEO from "@/components/SEO";
import { EMAIL } from "@/data/content";

const Cookie = () => (
  <>
    <SEO
      title="Cookie Policy — SOPAJ Impresa Edile"
      description="Informativa sui cookie del sito sopaj.it — Sopaj Demir Impresa Edile, Nibionno (LC)."
      path="/cookie-policy"
    />
    <div data-testid="cookie-page" className="max-w-3xl mx-auto px-5 md:px-8 pt-36 md:pt-48 pb-24 md:pb-36">
      <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-anthracite mb-12">Cookie Policy</h1>

      <section className="mb-10">
        <h2 className="font-display text-xl md:text-2xl tracking-tight text-anthracite mb-4">Cosa sono i cookie</h2>
        <p className="text-sm md:text-base text-anthracite/70 leading-relaxed">
          I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo
          dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti
          alla visita successiva.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="font-display text-xl md:text-2xl tracking-tight text-anthracite mb-4">Cookie utilizzati da questo sito</h2>
        <p className="text-sm md:text-base text-anthracite/70 leading-relaxed">
          Questo sito utilizza esclusivamente cookie tecnici, necessari al corretto
          funzionamento delle pagine e alla sicurezza del modulo di contatto. Non
          vengono utilizzati cookie di profilazione né cookie di terze parti a fini
          pubblicitari.
        </p>
        <p className="mt-3 text-sm md:text-base text-anthracite/70 leading-relaxed">
          La mappa di Google Maps presente nella pagina Contatti viene caricata solo
          quando visualizzata e può comportare l'installazione di cookie da parte di
          Google secondo la propria informativa.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="font-display text-xl md:text-2xl tracking-tight text-anthracite mb-4">Gestione dei cookie</h2>
        <p className="text-sm md:text-base text-anthracite/70 leading-relaxed">
          Puoi gestire o eliminare i cookie attraverso le impostazioni del tuo browser.
          Per informazioni o richieste puoi scrivere a {EMAIL}.
        </p>
      </section>
    </div>
  </>
);

export default Cookie;
